<script>
  import Fa from 'svelte-fa'
  import { faXmark } from '@fortawesome/pro-solid-svg-icons'

  /**
   * @typedef {Object} Props
   * @property {boolean} [visible]
   * @property {string} [title]
   * @property {() => void} [onclose]
   * @property {import('svelte').Snippet} [content]
   * @property {import('svelte').Snippet} [footer]
   */

  /** @type {Props} */
  let { visible = $bindable(false), title = '', onclose, content, footer } = $props()

  const close = () => {
    onclose?.()
  }

  const handleKeyDown = event => {
    if (event.key === 'Escape') {
      close()
    }
  }
</script>

<style>
  .fade-in {
    animation: fadeIn 0.3s ease-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
</style>

{#if visible}
  <div
    onclick={close}
    onkeydown={handleKeyDown}
    class="fixed inset-0 flex items-center justify-center z-[999] fade-in"
    style="background-color: rgba(0, 0, 0, 0.5);"
    role="button"
    tabindex="-1"
    data-cy="popup-modal"
  >
    <div
      class="bg-white rounded-lg shadow-lg w-11/12 max-w-lg relative"
      role="button"
      tabindex="-1"
      onclick={e => e.stopPropagation()}
      onkeydown={handleKeyDown}
    >
      <div class="flex justify-between items-center w-full border-b border-gray-100 p-4" data-cy="modal-header">
        <p class="text-xl text-gray-900 font-semibold">{title}</p>
        <button onclick={close} aria-label="Close modal">
          <Fa icon={faXmark} size="lg" class="text-gray-400" />
        </button>
      </div>
      {#if content}
        <div class="p-4">
          {@render content?.()}
        </div>
      {/if}
      {#if footer}
        <div class="p-4 border-t border-gray-100">
          {@render footer?.()}
        </div>
      {/if}
    </div>
  </div>
{/if}
